<template>
  <div class="enter">
    <p class="p"><el-link href="/" :underline="false">首页</el-link> / <span @click="detailHref">专家团队</span> / 首席合伙人</p>
    <dl class="detailDl">
      <dt class="floatLeft"><img :src="detailImg" /></dt>
      <dd class="floatRight">
        <h4 v-if="detailName == '朱翔坤'">{{detailName}}<span>{{detailLabel}}</span></h4>
        <h4 v-else-if="detailName == '趙塰嬿'" style="margin-top:36%;">Sabrina.赵<span>{{detailLabel}}</span></h4>
        <h4 v-else class="h4">{{detailName}}<span>{{detailLabel}}</span></h4>
        <div v-if="detailName == '趙塰嬿'" class="zhy">
          <br /><br />
          <p>心理学博士&emsp;美国内尔研究所（Neill Institute）</p>
          <p>管理与心理学博士后研究&emsp;英国剑桥大学(University of Cambridge)</p>
		  <p>心理学硕士&emsp;美国菲尔莱狄更斯大学</p>
          <p>工商管理硕士&emsp;法国布雷斯特学院(Brest Business School)</p>
          <br /><br />
          <p>注册国际高级心理咨询师(CISPC) : 2341E0077991</p>
          <p>积极心理学认证&emsp;清华大学</p>
		  <p>香港心理协会会员</p>
        </div>
        <div v-else-if="detailName == '朱翔坤'" class="zxk">
          <p class="p1">
            朱翔坤深受“爱与多元与包容性（D&I）”这一愿景的推动。作为VMC全球咨询公司的创始人，她为奢侈品牌和业界领先的独角兽公司提供咨询、培训和教练辅导服务。她还是InnerSight心理咨询有限公司的合伙人，并且拥有心理学博士学位。作为国际大学的客座讲师，以及艺术治疗师和摄影师，她具有多元的职业背景。让我们一同拥抱使命：通过“爱与多元与包容性”来丰富这个世界。
          </p>
          <p>伦敦国王学院神经科学和心理学硕士（在读）</p>
          <p>心理学博士，尼尔研究所</p>
          <p>高级工商管理硕士，蒙彼利埃大学</p>
          <p>管理与心理学博士后研究，剑桥大学</p>
          <p>HSA幸福研究学院认证教练及教育委员会成员， HSA ID #009716634I (lead by Harvard professor)</p>
          <p>剑桥认证高级执行教练</p>
          <p>剑桥认证生活教练</p>
          <p>美国认证学院国际高级心理咨询师认证：CISPC233790076350</p>
          <p>全球人本心理学会中国会长</p>
          <p>哈佛商学院线上上海（中国）会长⻓</p>
          <p>美国心理学会国际国际附属成员：C2204374902</p>
          <p>认证职业行为风格分析师（CPBA）</p>
          <p>认证职业动机分析师（CPMA）</p>
          <p>认证职业领导力与敏捷性分析师</p>
          <p>认证职业情绪智力分析师（CPEQA）</p>
          <p>发展心理学认证，北京大学</p>
          <p>积极心理学认证，清华大学</p>
          <p>奢华态度认证， IFG, INSEEC U</p>
          <p>哈佛商学院在线管理基础认证，ID #201700025076</p>
          <p>心理急救（PFA）在线认证</p>
          <p>用于物质使用障碍治疗的数字治疗：科学现状及未来愿景，斯坦福大学医学院认证</p>
          <p>项目管理和敏捷项目管理，谷歌认证</p>
          <p>博弈论，斯坦佛认证</p>
        </div>
        <div v-else class="detailDd">
          <div v-for="(item,index) in textList" :key="index">
            <template v-if="item.name == detailName">
              <b>学历背景：</b>
              <p v-for="(row) in (item.xllabel).split(',')">{{row}}</p>
              <b>专业受训：</b>
              <p v-for="(row) in (item.zytext).split(',')">{{row}}</p>
            </template>
          </div>
        </div>
      </dd>
    </dl>
  </div>
</template>
<script>
  export default {
    props: ['detailName', 'detailLabel', 'detailImg'],
    data() {
      return {
        textList: [{
            name: '郎依',
            xllabel: '北京师范大学 心理学本科,上海财经大学工商管理MBA,国家二级心理咨询师',
            zytext: '德瑞姆德心班精神分析动力取向两年制培训项目,C级沙盘游戏咨询师培训项目,中美人格障碍的评估诊断与治疗连续培训项目,候选荣格分析师三年制培训课程,中美短程家庭治疗连续培训项目（三年）,上海精神卫生中心临床心理专项进修班'
          },
          {
            name: '王亿雯',
            xllabel: '北京师范大学 心理学 本科,国家三级心理咨询师',
            zytext: "德瑞姆德心班精神分析动力取向两年制培训项目,中挪精神动力学心理治疗连续培训项目 3年制,自体心理学连续培训项目 3年制,上海浦东精神卫生中心-系统式心身医学与心理治疗研修与实习 2年"
          },
          {
            name: '武清云',
            xllabel: "北京师范大学 心理学本科",
            zytext: "一沙心理专业培训项目2年,德瑞姆德心班精神分析动力取向两年制培训项目,糖心理心理学家直面受训150小时以上,美国NGH催眠认证治疗师,德济医院神经心理科实习项目,长期医疗临床工作经验和心理学专业培训背景,熟知身心疾病、 躯体症状及相关障碍 "
          },
          {
            name: '张晓菲',
            xllabel: '华东师范大学教育系本科,马德里康普斯顿大学临床心理学硕士',
            zytext: "纽约怀特精神分析学院 强化心理分析心理治疗IPPP项目,心寻心理-精神分析动力取向两年长程培训 高级组,德瑞姆德心班精神分析动力取向两年制培训项目,张沛超精神分析本土化与整合连续培训项目初-中级班,温尼科特精神范式基础理论与临床技术,中美人格障碍评估诊断与治疗连续培训项目,徐钧自体心理学四年连续培训项目,聚焦取向心理治疗国际项目连续培训"
          },
          {
            name: '方敏',
            xllabel: "华中师范大学 应用心理学硕士,国家二级心理咨询师",
            zytext: "心寻心理-精神分析动力取向两年长程培训 初级组,心寻心理-精神分析动力取向两年长程培训 高级组,简单心理-儿童精神分析入门培训,中美人格障碍的评估诊断与治疗连续培训项目",
          },
          {
            name: '琳晨',
            xllabel: "日本东京中央大学人文社会学科心理系 本科,国家二级心理咨询师",
            zytext: "日本东京多摩儿童心理健康发展中心实习,沙盘游戏长期培训项目,德瑞姆德心班精神分析动力取向两年制培训项目,中美人格障碍的评估诊断与治疗连续培训项目,上海精神卫生中心临床心理专项进修班,候选荣格分析师三年制培训课程"
          },
          {
            name: '俞嘉溦',
            xllabel: "南京大学 应用心理学学士,10年+高中心理老师",
            zytext: "南京大学Peer Counseling系列课程,萨提亚家庭重塑培训师培训课程（初级-进阶）,沙盘游戏疗法系列培训班,人格障碍的心理动力学诊断和治疗连续培训项目,生命自觉（聚焦）初阶至四阶课程"
          },
          {
            name: '刘琴琴',
            xllabel: "北京吉利学院社区康复（心理保健与咨询）本科,广州大学应用心理硕士,心理咨询师三级,心理健康教师",
            zytext: "美国学院制2年儿童青少年精神分析项-简单心理,Uni心理咨询师培养计划-简单心理,LGBT性少数群体咨询培训-多元心理,曾在合肥长兴康复医院 精神康复科任职一年"
          },
          {
            name: '邓伟光',
            xllabel: "华东师范大学应用心理硕士,高校心理中心兼职咨询师,中级学校心理咨询师,上海市心理卫生服务行业协会咨询师",
            zytext: "家庭治疗培训项目（两年）,一沙心理临床咨询师受训项目（两年）,许维素焦点解决短期疗法,当代自体心理学临床实践培训项目,自体心理学视角下儿童青少年心理治疗研讨班,和导师学习叙事治疗及家庭治疗理论和实践,精神科诊所医学助理（一年）,参与翻译《儿童虐待的精神分析：理解与治疗》已出版；"
          },
          {
            name: '任羽骏',
            xllabel: "西北师范大学应用心理专业硕士,国家二级心理咨询师",
            zytext: "杨凤池一年制分析体验式心理咨询研修班,盛晓春系统式家庭治疗师认证培训,WMECA国际催眠师认证培训,慧开心理九型人格工作坊,傅安球催眠培训,方刚性与亲密关系咨询师认证培训"
          },
          {
            name: '高健峰',
            xllabel: "同济大学临床与咨询心理学（家庭治疗方向）硕士,国家三级心理咨询师,上海市精神卫生中心（浦东分院）心理咨询师",
            zytext: "吴熙琄叙事疗法连续培训,同济大学心理健康教育与咨询中心实习咨询师,上海精神卫生中心辩证行为学习培训,美国陶斯学院（Taos Institute）国际合作对话项目（ICCP）参与和文献翻译"
          },
          {
            name: '卢浩然',
            xllabel: "华东师范大学应用心理学本科,马德里康普斯顿大学临床心理学硕士,国家二级心理咨询师",
            zytext: "德瑞姆德心班精神分析动力取向两年制培训项目,中美人格障碍的评估诊断与治疗连续培训项目,徐凯文心理危机干预专项系统培训"
          }
        ],
      }
    },
    created() {
      const currentPosition = window.pageYOffset || document.documentElement.scrollTop;
      if (currentPosition > 0) {
        // 如果当前位置不为零，则执行滚动操作
        this.$nextTick(() => {
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        });
      }
    },
    methods: {
      detailHref() {
        this.$emit('updateParentValue', '1');
      }
    }
  }
</script>

<style scoped>
  .enter {
    width: 950px;
    margin: 0 auto 100px auto;
    display: table;
  }

  .enter .p {
    font-size: 14px;
    padding: 30px 0;
  }

  .enter .p span {
    cursor: pointer;
  }

  .enter .p a {
    font-size: 14px;
  }



  .detailDl dt img {
    width: 432px;
  }

  .detailDl dd {
    width: 468px;
    height: 570px;
    background: url("../assets/bj.jpg") no-repeat right bottom;
    background-size: 80%;
  }

  .detailDl dd h4 {
    font-size: 18px;
    font-weight: bold;
    color: #333;
  }

  .detailDl dd h4.h4 {
    margin-top: 28%;
  }

  .detailDl dd h4 span {
    font-size: 16px;
    font-weight: bold;
    color: #333;
    padding-left: 25px;
  }

  .zxk .p1 {
    text-indent: 24px;
    padding: 10px 0;
  }

  .zxk p,
  .detailDd p,
  .zhy p {
    color: #4A4A4A;
    font-size: 14px;
    line-height: 22px;
  }

  .zxk p {
    font-size: 13px;
    line-height: 18px;
  }

  .zhy p {
    font-size: 14px;
  }

  .detailDd b {
    font-size: 14px;
    padding: 30px 0 6px 0;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/expertDetail.vue